<template>
  <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a target="_blank" href="http://www.solidtectecnologia.com.br/">SolidTec Tecnologia</a>.</strong> Todos os direitos reservados.
    </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?d6f2f854